<template>
  <!-- zvonce: samo za prijavljenog kupca; lista se ucitava kad se otvori, a znacka se osvezava u pozadini -->
  <BDropdown v-if="visible"
             ref="dropdown"
             variant="white"
             class="dropdown d-inline-block me-3"
             toggle-class="header-item noti-icon"
             right
             menu-class="dropdown-menu-end p-0 bell-menu"
             @show="onOpen">
    <template #button-content>
      <i class="esei icon-bell-solid"></i>
      <span v-if="store.unread > 0" class="badge bg-danger rounded-pill">{{ store.unread > 99 ? '99+' : store.unread }}</span>
    </template>

    <div class="bell-head">
      <span class="bell-head-title">Obaveštenja</span>
      <button v-if="store.unread > 0" type="button" class="bell-all" @click.stop="store.readAll()">Označi sve kao pročitano</button>
    </div>

    <div class="bell-list">
      <p v-if="store.loading && !store.items.length" class="bell-empty">Učitavanje…</p>
      <p v-else-if="!store.items.length" class="bell-empty">Nemate obaveštenja.</p>

      <NuxtLink v-for="item in store.items"
                :key="item.id"
                :to="item.url"
                class="bell-item"
                :class="{ 'bell-unread': item.unread }"
                @click="open(item)">
        <span class="bell-icon" :class="`bell-icon-${item.type}`">
          <i class="esei" :class="iconFor(item.type)" aria-hidden="true"></i>
        </span>
        <span class="bell-text">
          <span class="bell-title">{{ item.title }}</span>
          <span v-if="item.body" class="bell-body">{{ item.body }}</span>
          <span class="bell-time">{{ ago(item.created_at) }}</span>
        </span>
        <span v-if="item.unread" class="bell-dot" aria-label="Nepročitano"></span>
      </NuxtLink>
    </div>

    <NuxtLink to="/korisnicki-profil/obavestenja" class="bell-foot" @click="close">Sve poruke</NuxtLink>
  </BDropdown>
</template>

<script setup>
import { BDropdown } from 'bootstrap-vue-next'
import { useCustomerLoginStore } from '~/stores/login/customer'
import { useNotificationStore } from '~/stores/notifications'

const login = useCustomerLoginStore()
const store = useNotificationStore()

const dropdown = ref(null)
const visible = computed(() => !!login.loggedIn)

const { iconFor, ago } = useNotificationDisplay()

const close = () => {
  if (dropdown.value) dropdown.value.visible = false
}

const open = (item) => {
  store.markRead(item)
  close()
}

// otvaranje: ucitaj listu, pa oznaci opsta obavestenja viđenima (znacka ostaje samo za licna nepročitana)
const onOpen = async () => {
  await store.fetchFeed()
  store.markSeen()
}

// brojac se uzima jednom, pri ucitavanju stranice (osvezavanje), i kad se kupac prijavi; lista se uzima pri otvaranju zvonca
// ako je broj stigao sa serverom uz proveru prijave (SSR), poseban poziv nije potreban
onMounted(() => {
  if (visible.value && !store.loaded) store.fetchCount()
})

watch(visible, (isVisible) => {
  if (!isVisible) store.reset()
  else if (!store.loaded) store.fetchCount()
})
</script>
